import { Injectable, inject } from '@angular/core';
import { DfpFinancialReadingResponse } from '@interfaces/dfp/response/dfpFinancialReadingResponse';
import { VaultApiService } from '@services/api/vault-api.service';
import { Observable } from 'rxjs';

/** Leitura do Cog dos demonstrativos da DFP Histórica (card 3801). */
@Injectable({ providedIn: 'root' })
export class DfpFinancialReadingService {
  private readonly api = inject(VaultApiService);
  private readonly baseUrl = 'dfp-historical/financial-reading';

  /** Estado e última leitura da empresa. */
  get(companyId: string): Observable<DfpFinancialReadingResponse | null> {
    return this.api.get<DfpFinancialReadingResponse>(this.baseUrl, {}, { companyId });
  }

  /**
   * "Gerar de novo" / "Gerar agora": enfileira na hora, sem esperar a varredura. `companyId` vai na URL à mão: o
   * `VaultApiService` só monta query string em GET; no POST o objeto viraria corpo.
   */
  generate(companyId: string): Observable<DfpFinancialReadingResponse | null> {
    const query = new URLSearchParams({ companyId }).toString();
    return this.api.post<DfpFinancialReadingResponse>(`${this.baseUrl}/generate?${query}`, {});
  }
}
